<div class="dashboard__tile__title">
    <span>Resource budgets approaching 80%</span>
    <button
        type="button"
        class="button button--icon button--small"
        (click)="goToBudgets()">
        <i class="uil uil-arrow-right"></i>
    </button>
</div>

<div
    class="dashboard__tile__content"
    *ngIf="rows$ | async as items; else loading">
    <div *ngIf="items && items.length > 0; else empty">
        <div class="table__overflow">
            <table
                mat-table
                [dataSource]="dataSource"
                class="resource-budgets-table">
                <ng-container matColumnDef="employee">
                    <th mat-header-cell *matHeaderCellDef class="table-employee-column">Employee</th>
                    <td mat-cell *matCellDef="let row">
                        <app-pill-employee
                            *ngIf="row.budget?.linkedEmployee?.uuid"
                            [employeeId]="row.budget.linkedEmployee.uuid"></app-pill-employee>
                        <span *ngIf="!row.budget?.linkedEmployee?.uuid">-</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="budget">
                    <th mat-header-cell *matHeaderCellDef>Budget</th>
                    <td mat-cell *matCellDef="let row">
                        <button
                            type="button"
                            class="budget-cell budget-cell--button"
                            title="Open budget"
                            (click)="openBudget(row)">
                            <span class="budget-cell__header">
                                <span class="budget-cell__type">{{ row.budget?.budgetType || '-' }}</span>
                                <span
                                    *ngIf="row.outOfPhase"
                                    class="phase-badge"
                                    [title]="'Expected usage by now: ' + (row.expectedUtilization | number: '1.0-0') + '%'">
                                    Out of phase
                                </span>
                            </span>
                            <span class="budget-cell__amounts">
                                <strong>{{ row.actualSpend | currency: 'EUR':'symbol':'1.0-0' }}</strong>
                                <span class="budget-cell__separator">/</span>
                                {{ row.totalBudget | currency: 'EUR':'symbol':'1.0-0' }}
                            </span>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="usage">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Used</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        <span [class]="usageClass(row.utilization)">
                            {{ row.utilization | number: '1.0-0' }}%
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="over">
                    <th mat-header-cell *matHeaderCellDef class="text-right">Over</th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        <span *ngIf="row.deficit > 0" class="deficit">
                            +{{ row.deficit | currency: 'EUR':'symbol':'1.0-0' }}
                        </span>
                        <span *ngIf="!row.deficit || row.deficit <= 0" class="muted">-</span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
</div>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
<ng-template #empty>
    <app-message-empty
        [title]="'All resource budgets are healthy!'"
        [icon]="'../../assets/img/open-box.png'">
    </app-message-empty>
</ng-template>
